export default __webpack_public_path__ + "static/media/inventory.efa1a697.svg";